import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment/moment';

@Pipe({
    name: 'dateFormat'
})
export class DateFormat implements PipeTransform {
    transform(value: any, args?: string[]): any {
        if (value) {
            const date = value instanceof Date ? value : new Date(value);
            return moment(date).format('D MMM YYYY ');
        }
    }
}

@Pipe({name: 'decimal'})
export class DecimalPipe implements PipeTransform {
    /**
     *
     * @param value
     * @returns {number}
     */
    transform(value: number): number {
        return Math.round(value * 100) / 100;
    }
}
